module.exports = __webpack_public_path__ + "static/businesses_4-19c188c6afb40bb7bcb124436c97d2e9.svg";